export class User {
  constructor(
    public id: number,
    public lastName: string,
    public firstName: string,
    public email: string,
    public password: string,
    public street: string,
    public zip: number,
    public country: number,
    public city: string,
    public role: string,
    public isLocked: boolean
  ) {
  }
}
export interface SearchUserResponse {
  content: User[];
  totalElements: number;
}
